import "./Registry.module.css";
import Header from "@/reusable_sections/Header";
import RegistryIntroduction from "./sections/RegistryIntroduction";
import GiftOptions from "./sections/GiftOptions";
import ContributeNow from "./sections/ContributeNow";
import RegistrationFaq from "./sections/RegistrationFaq";
import Footer from "@/reusable_sections/Footer";
export default function RegistryPage() {
  return <div>
      <Header />
      <RegistryIntroduction />
      <Footer />
    </div>;
}